import { useController, ApplicationView } from '@aha-app/mvc';
import WhiteboardContainerController from '../WhiteboardContainerController';
import React from 'react';
import classNames from 'classnames';

const CommentsSidePanelTitleButtons = () => {
  const controller = useController(WhiteboardContainerController);
  const { commentsVisible } = controller.state;
  return (
    <div className='btn-group'>
      <button
        onClick={() => controller.actionSetCommentsVisible(true)}
        className={classNames('btn btn-default btn-small', {
          active: commentsVisible,
        })}
      >
        <i className='fa-regular fa-comment' />
      </button>
      <button
        onClick={() => controller.actionSetCommentsVisible(false)}
        className={classNames('btn btn-default btn-small', {
          active: !commentsVisible,
        })}
      >
        <i className='fa-regular fa-comment-slash' />
      </button>
    </div>
  );
};

export default ApplicationView(CommentsSidePanelTitleButtons);
